import { CheckStatusEnum } from '@dotfile/shared/domain';

export const PendingStatuses: CheckStatusEnum[] = [
  CheckStatusEnum.in_progress,
  CheckStatusEnum.rejected,
  CheckStatusEnum.expired,
];

export const UnderReviewStatuses: CheckStatusEnum[] = [
  CheckStatusEnum.need_review,
  CheckStatusEnum.processing,
];

export const CASE_CHECK_INTERVAL_POLLING_IN_MS = 5 * 1000; // 5seconds
